// extracted by mini-css-extract-plugin
export default {"container":"container__9-t2u","notifications-list":"notifications-list__OviAW","item":"item__88Cgn"};